import NotoSansBold from "$assets/fonts/noto-sans/noto-sans-bold.woff2";
import NotoSansRegular from "$assets/fonts/noto-sans/noto-sans-regular.woff2";
import { GlobalStyles } from "$global-providers/mui-provider/global-styles";
import { generateOverrides } from "$global-providers/mui-provider/overrides";
import { createTheme, ThemeProvider } from "@material-ui/core";
import { useMemo } from "react";
import type { Font } from "./overrides";
import { PALETTE } from "./palette";
import { PROPS } from "./props";
import { TYPOGRAPHY } from "./typography";

const FONTS = [
  {
    fontFamily: "NotoSans Regular",
    src: `url(${NotoSansRegular}) format('woff2')`,
    fontWeight: "normal",
    fontStyle: "normal",
    fontSmoothing: "antialiased",
  },
  {
    fontFamily: "NotoSans Bold",
    src: `url(${NotoSansBold}) format('woff2')`,
    fontWeight: "normal",
    fontStyle: "normal",
    fontSmoothing: "antialiased",
  },
] satisfies Font[];

export const MuiProvider: FCwC = ({ children }) => {
  const theme = useMemo(
    () =>
      createTheme({
        typography: TYPOGRAPHY,
        palette: PALETTE,
        props: PROPS,
        overrides: generateOverrides({ fonts: FONTS }),
      }),
    [],
  );
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
};
